import { CalendarPicker, LocalizationProvider } from "@mui/lab";
import { Rating } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import "./provider.css";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Button from "../../components/button/Button";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getJWT } from "../../helpers/Helper";
import { toast, ToastContainer } from "react-toastify";
import { AuthContext } from "../../contexts/AuthContext";

// const minDate = new Date(new Date());
// const maxDate = new Date('2034-01-01T00:00:00.000');

const renderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center", padding: "10rem" }}>
    <Spinner animation="border" variant="darke" />
  </div>
);

const renderLoadingButton = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="light" />
  </div>
);

function Provider() {
  const navigate = useNavigate();

  const { authState, handleShowAuthModal } = useContext(AuthContext);

  const [rateDetails, setRateDetails] = useState();

  console.log(rateDetails);

  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [location, setLocation] = useState();
  const [time, setTime] = useState();
  const [date, setDate] = useState(new Date());
  const [unit, setUnit] = useState();

  console.log(time);

  const [loading, setLoading] = useState(false);
  const [vendorData, setVendorData] = useState();

  const [loadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    setLoading(true);
    const { id } = queryString.parse(window.location.search);

    if (id === null || undefined) {
      navigate("/error");
    } else {
      axios
        .get(
          `https://the-outlet-vendor-api.herokuapp.com/vendor-services/${id}`
        )
        .then((res) => {
          setVendorData(res && res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err.response.data.error);
          navigate("/");
        });

      axios
        .get(
          `https://the-outlet-vendor-api.herokuapp.com/vendor-services/${id}/ratings`
        )
        .then((res) => {
          setRateDetails(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err.response.data.error);
        });
    }
  }, []);

  const bookingInput = [
    {
      placeholder: "Event Name",
      type: "text",
      value: name,
      onChange: (e) => setName(e.target.value),
    },
    {
      placeholder: "Event Description",
      type: "description",
      value: description,
      onChange: (e) => setDescription(e.target.value),
    },
    {
      placeholder: "Event Location",
      type: "text",
      value: location,
      onChange: (e) => setLocation(e.target.value),
    },
    {
      placeholder: `How many ${vendorData && vendorData.unit}s`,
      type: "number",
      value: unit,
      onChange: (e) => setUnit(e.target.value),
    },
  ];

  const handleBooking = () => {
    setLoadingButton(true);

    axios
      .post(
        `https://the-outlet-vendor-api.herokuapp.com/bookings`,
        {
          date: date,
          title: name,
          description: description,
          location: location,
          vendorServiceId: vendorData && vendorData.id,
          units: unit,
        },
        { headers: { Authorization: `Bearer ${getJWT()}` } }
      )
      .then((res) => {
        console.log(res.data);
        // alert("Vendor Successfully booked!")
        window.location.href = res && res.data.link;
        toast("Vendor Successfully booked!", {
          type: "success",
          position: "top-right",
          autoClose: "5000",
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoadingButton(false);
        // navigate('/')
      })
      .catch((err) => {
        toast(`Ooops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "5000",
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoadingButton(false);
      });
  };

  return (
    <div className="provider">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      {loading ? (
        renderLoading()
      ) : (
        <React.Fragment>
          {vendorData && (
            <div className="main_section">
              <Row className="section-1">
                <Col md={3} sm={12}>
                  <img src={vendorData} />
                </Col>
                <Col md={8} sm={12} style={{ paddingLeft: "1rem" }}>
                  <h1>
                    {vendorData.vendor.name} - {vendorData.name}
                  </h1>
                  <div className="quality_details">
                    <h6>{vendorData.service.name}</h6>

                    {vendorData.isAvailable ? (
                      <h6>Available</h6>
                    ) : (
                      <h6>unavailable</h6>
                    )}

                    <Rating
                      name="read-ony"
                      className="rating"
                      value={vendorData.averageRating}
                      precision={0.5}
                      readOnly
                    />
                    <h6>({vendorData.averageRating})</h6>
                  </div>
                  <div className="quality_details">
                    <div className="detail">
                      <h6>Language</h6>
                      <p>English</p>
                    </div>

                    <div className="detail">
                      <h6>Gender</h6>
                      <p>Male</p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="section-2">
                <Col xl={6} md={12} sm={12} className="bio">
                  <h4>About the {vendorData.service.name} </h4>
                  <p>{vendorData.description}</p>

                  <Row>
                    {vendorData &&
                      vendorData.images.map((image) => (
                        <Col md={3} sm={6} xs={6}>
                          <img
                            key={image.imageId}
                            src={image.imageUrl}
                            alt="Portfolio"
                            className="portfolioImage"
                          />
                        </Col>
                      ))}
                  </Row>
                </Col>
                <Col xl={5} md={12} sm={12} className="book-card">
                  <div className="rate">
                    <h6>{`Rate per ${vendorData.unit}`}</h6>
                    <h5>KShs {vendorData.price}</h5>
                  </div>

                  <div className="booking_form-wrapper">
                    {bookingInput.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.type === "text" ? (
                          <React.Fragment>
                            <label>{item.placeholder}*</label>
                            <input
                              type={item.type}
                              placeholder={item.placeholder}
                              value={item.value}
                              onChange={item.onChange}
                            />
                          </React.Fragment>
                        ) : null}
                        {item.type === "number" ? (
                          <React.Fragment>
                            <label>{item.placeholder}*</label>
                            <input
                              type={item.type}
                              placeholder={item.placeholder}
                              value={item.value}
                              onChange={item.onChange}
                            />
                          </React.Fragment>
                        ) : null}
                        {item.type === "description" ? (
                          <React.Fragment>
                            <label>{item.placeholder}*</label>
                            <textarea
                              id="event_description"
                              name="event_description"
                              rows="4"
                              placeholder={item.placeholder}
                              value={item.value}
                              onChange={item.onChange}
                            />
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </div>

                  <p style={{ marginTop: "1rem" }}>
                    Please input the starting of the event
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <CalendarPicker
                      date={date}
                      onChange={(newDate) => setDate(newDate)}
                    />
                  </LocalizationProvider>

                  <div className="time_picker">
                    <p>Please input the time of the event</p>
                    <input
                      type="time"
                      value={time}
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>

                  <div className="book-btn">
                    {authState !== undefined ? (
                      <Button
                        onClickHandler={handleBooking}
                        content={loadingButton ? renderLoadingButton() : `Book`}
                        contentColor="white"
                        borderRadius="all"
                        buttonColor="main-bg"
                      />
                    ) : (
                      <Button
                        onClickHandler={() => {
                          handleShowAuthModal();
                        }}
                        content="Book"
                        contentColor="white"
                        borderRadius="all"
                        buttonColor="main-bg"
                      />
                    )}
                  </div>
                </Col>
              </Row>

              <div className="section-3">
                <h4>COMMENTS</h4>
                <div className="comments">
                  {rateDetails &&
                    rateDetails.map((comment, index) => {
                      const timestamp = comment.updatedAt;
                      const date = new Date(timestamp);

                      return (
                        <div key={index} style={{ padding: "1.5rem 0rem" }}>
                          <div className="commentor">
                            <i class="bx bxs-user-circle"></i>
                            <h5>
                              {comment.booking.customer &&
                                comment.booking.customer.name}
                            </h5>
                          </div>
                          <div className="comment">{comment.comment}</div>
                          <div className="publishDate">
                            <h6>{`Published on ${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`}</h6>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      )}

      <ToastContainer />

      <Footer />
    </div>
  );
}

export default Provider;
